import React from 'react';
import { node } from 'prop-types';
import { ImageList } from '@mui/material';

const MediaGrid = ({ children }) => (
  <ImageList sx={{ width: '100%', paddingTop: '20px' }} spacing={20} cols={7} cellHeight={112}>
    {children}
  </ImageList>
);

MediaGrid.propTypes = {
  children: node.isRequired,
};

export default MediaGrid;
